/**
 * List of USSD gateways currently supported by default.
 */
export enum SupportedGateway {
	wigal = "wigal",
	emergent_technology = "emergent_technology",
}

export const MAXIMUM_CHARACTERS = 182;
